import { useEffect } from "react";
import { store } from "../_store";

/**
 * Socket listener for group chat. It will listen to new messages in section.
 * It will update realtime section badge count.
 *
 * @param socket Socket instance.
 */
export const useSocketGroupChatListener = (
  socket: any,
  IncreaseGroupChatBadgeCount = (e: string) => {}
) => {
  // Add socket listeners
  useEffect(() => {
    if (!socket || !socket.connected) {
      return;
    }

    debugSocket("Socket listeners connected", "");
    socket.on("new-section-message-badge", (data: any) => {
      debugSocket("Socket event", data);
      if (data.sectionId) {
        store.dispatch(IncreaseGroupChatBadgeCount(data.sectionId));
      }
    });

    return () => {
      socket.off(`new-section-message-badge`, () => {});

      debugSocket("Socket listeners removed", "");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket?.connected]);

  function debugSocket(eventName: string, data?: any | undefined) {
    // console.log("SOCKET", eventName, data);
  }
};
